// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"257ac55f","464":"3e84c8ba"}[chunkId] + ".chunk.css";
};